import { buildWaLink } from 'features/misc/api/getProducts';
import { WhatsAppIcon } from '../icons/WhatsAppIcon';

export function WhatsAppFloat() {
  return (
    <a
      href={buildWaLink("Hi Chikwafu, I'd like to chat")}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25d366] shadow-lg shadow-[#25d366]/40 transition-transform hover:scale-110"
    >
      <WhatsAppIcon className="h-7 w-7 text-white" />
    </a>
  );
}
